export const isTextType = (type) => ["text", "textarea"].includes(type);
export const isOptionType = (type) =>
  ["checkbox", "select", "radio"].includes(type);
export const isAllowedQuota = (type) => ["select", "radio"].includes(type);
export const isFileType = (type) => type == "file";
export const allowQuickEdit = (type) => ["select", "text"].includes(type);
export const validatorLimits = (type) => !["phone", "date"].includes(type);
export const isPlaceholderType = (type) =>
  ["text", "textarea", "select"].includes(type);
export const canChangeWidth = (type) => type !== "file";
export const isListType = (type) => ["file", "checkbox"].includes(type);
export const widthName = (width) => {
  switch (width) {
    case 1:
      return "full";
    case 2:
      return "half";
    case 3:
      return "third";
    default:
      return "full";
  }
};
